import React, { createContext, PropsWithChildren, useContext } from 'react';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import R6PayService from '../services/R6PayService';

export interface R6PayContextProps {
    service: R6PayService;
}

export interface R6PayContextDefaultProps {
    service: R6PayService | null;
}

export const R6PayContext = createContext<R6PayContextDefaultProps>({
    service: null,
});

// Not used right now but will be in the future when we have multiple providers
export const R6PayProvider = ({
    children,
    location,
}: PropsWithChildren<{ location: Location }>) => {
    const service = new R6PayService(location, window.rapidstor_settings.app_config.journey.dev);

    return <R6PayContext.Provider value={{ service }}>{children}</R6PayContext.Provider>;
};

export const useR6PayContext = (location: Location) => {
    const context = useContext(R6PayContext);

    if (!context.service && location.rapidstor.paymentGateways.use) {
        if (location.rapidstor.paymentGateways.gateways.r6Pay) {
            context.service = new R6PayService(location, window.rapidstor_settings.app_config.journey.dev);
        }
    }

    return context as R6PayContextProps;
};
